import React, { useMemo } from 'react';
import { Tag } from 'antd';
import { CheckCircleOutlined, ClockCircleOutlined, SyncOutlined } from '@ant-design/icons';
import type { ITripStatusTagProps } from './types';

export const TripStatusTag: React.FC<ITripStatusTagProps> = (props) => {
  const { status, className } = props;

  const getTagProps = (): { color: string; icon: React.ReactNode } => {
    switch (status) {
      case 'planning':
        return { color: '', icon: <ClockCircleOutlined /> };
      case 'ready':
        return { color: 'gold', icon: <ClockCircleOutlined /> };
      case 'progress':
        return { color: 'blue', icon: <SyncOutlined /> };
      case 'done':
        return { color: 'green', icon: <CheckCircleOutlined /> };
    }
  };

  const tagProps = useMemo(getTagProps, [status]);

  return (
    <Tag className={className} {...tagProps}>
      {status}
    </Tag>
  );
};
